module.exports = __webpack_public_path__ + "static/media/SouthWesternTimes-socshare-min.52b6a8a0.jpg";